export const RELEASES_SORT = [
    {
        icon: 'sort-a-z',
        sprite: 'navigation',
        code: 'title',
        direction: 'asc',
        name: 'sort.default.title'
    }, {
        icon: 'calendar',
        sprite: 'sections',
        code: 'createdAt',
        direction: 'desc',
        name: 'sort.default.created_date'
    }, {
        icon: 'calendar',
        sprite: 'sections',
        code: 'updatedAt',
        direction: 'desc',
        name: 'sort.default.edited_date'
    }, {
        icon: 'sort-9-1',
        sprite: 'navigation',
        code: 'duration',
        direction: 'asc',
        name: 'sort.default.duration'
    }
]
